import produce from 'immer';
import { NFT_RESTORE_LOG_LIST_REQUEST } from '../../constants/log/nftRestoreLogConstants';

const initialState = {

};

const nftRestoreLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case NFT_RESTORE_LOG_LIST_REQUEST:
    break;
    default:
      break;
  }
});

export default nftRestoreLogReducer;
